module.exports = __webpack_public_path__ + "static/media/2img.4943de25.png";